import styles from "./css/BusinessContainer.module.css";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Instagram } from "@mui/icons-material";
import { privacyPolicyUrl, termsOfUseUrl } from "./contants";
import ContactUsModal from "./ContactUsModal";

export default function BusinessContainer() {
  const { t } = useTranslation();
  const [showContactUs, setShowContactUs] = useState(false);

  function handleOnClickPrivacyPolicyButton() {
    window.open(privacyPolicyUrl);
  }

  function handleOnClickTermsOfUseButton() {
    window.open(termsOfUseUrl);
  }

  function handleOnClickEmail() {
    setShowContactUs(true);
  }

  function handleOnClickInstagramButton() {
    window.open("https://www.instagram.com/m_i_n_th/");
  }

  return (
    <>
      <div className={styles.container}>
        <div className={styles.contentContainer}>
          <p className={styles.companyNameText}>MNIS</p>
          <p className={styles.companyRegistrationNumberText}>
            {`${t("BusinessRegistrationNumber")} : 8282600960 | ${t(
              "CommerceBusinessRegistrationNumber"
            )} : 제 2025-서울송파-2751 | ${t("Representative")} : ${t("Name")}
             | zak1ller.kr@gmail.com`}
          </p>
          <p className={styles.companyAddressText}>{t("Address")}</p>
          <p
            className={styles.contactAddressText}
            onClick={() => handleOnClickEmail()}
          >
            {`${t("ContactUs")} : zak1ller.kr@gmail.com`}
          </p>
          <div className={styles.privacyPolicyContainer}>
            <button
              className={styles.buttonText}
              onClick={() => handleOnClickTermsOfUseButton()}
            >
              {t("TermsOfUse")}
            </button>
            <button
              className={styles.buttonText}
              onClick={() => handleOnClickPrivacyPolicyButton()}
            >
              {t("PrivacyPolicy")}
            </button>
          </div>
          <div className={styles.socialLinkButtonContainer}>
            <Instagram
              onClick={() => handleOnClickInstagramButton()}
              style={{
                fontSize: 32,
                cursor: "pointer",
                color: "var(--icon-default-color)",
              }}
            />
          </div>
        </div>
      </div>
      <ContactUsModal
        open={showContactUs}
        onClose={() => setShowContactUs(false)}
      />
    </>
  );
}
